// extracted by mini-css-extract-plugin
export var copyableItem = "_c-0";
export var underlined = "_c-1";